import React from 'react';
import { useNavigate } from 'react-router-dom';

function AbsoluteFooter() {
    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const redirectToPrivacyPolicy = () => {
        navigate("/privacypolicy");
    };
    return (
        <div dir="ltr" className="w-full py-2 px-5 absolute bottom-0 text-white justify-center flex gap-2">
            <span className="text-white">
                © {currentYear}
            </span>
            <span className="primary-text font-bold">
                DODEAL
            </span>
            <span>|</span>
            <span>All Rights Reserved </span>
            <span>|</span>
            <div
                onClick={redirectToPrivacyPolicy}
            >
                Privacy Policy
            </div>
        </div>
    );
}

export default AbsoluteFooter;
